import React from 'react';
import PropTypes from 'prop-types';
import notifyBugsnag from '../../../util/notifyBugsnag';

class ComponentErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    const { name } = this.props;
    notifyBugsnag(error, {
      errorBoundary: {
        componentStack: info?.componentStack,
        name: name || 'ComponentErrorBoundary',
      },
    });
  }

  render() {
    const { hasError } = this.state;
    const { fallback, children } = this.props;
    if (hasError) {
      return fallback ?? null;
    }
    return children;
  }
}

ComponentErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  fallback: PropTypes.node,
  name: PropTypes.string,
};

ComponentErrorBoundary.defaultProps = {
  fallback: null,
  name: null,
};

export default ComponentErrorBoundary;
